import { siteConfig } from "@/config/site.config";
import cn from "@/utils/class-names";

interface LogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    iconOnly?: boolean;
}

export default function Logo({
    iconOnly = false,
    className,
    alt,
    ...props
}: LogoProps) {
    return (
        <img
            src={siteConfig.logo}
            alt={alt ?? siteConfig.title}
            className={cn(
                className,
            )}
            {...props}
        />
    );
}
